import React, { useEffect, useState } from "react";
import NodeNameValidation from "../../atoms/node-name-validation";
import ConditionSelector from "../condition-selector";
import { cloneDeep } from "lodash";
import { t } from "../../../utils/utils";
export default function NodeIfProperty({ node, nodeChange, dependencies }) {
  const [inputData, setInputData] = useState({});
  const [selectors, setSelectors] = useState([]);

  const [logic, setLogic] = useState("");
  useEffect(() => {
    const { args } = node.properties;
    if (args) {
      if (args.inputData) {
        setInputData(args.inputData);
      }
      if (args.conditions) {
        const tmpLogic = Object.keys(args.conditions)[0];
        setLogic(tmpLogic.replace("$", ""));
        setSelectors(
          args.conditions[tmpLogic].map(o => {
            const operator = Object.keys(o)[0];
            return {
              operator: operator.replace("$", ""),
              left: o[operator][0],
              right: o[operator][1]
            };
          })
        );
      }
    }
  }, [node]);
  const conditionVariables = o => {
    const variables = [];
    if (o.left) {
      variables.push(o.left.replace("$", ""));
    }
    if (o.right) {
      variables.push(o.right.replace("$", ""));
    }
    return variables;
  };
  const onSubmit = name => {
    const tmp = cloneDeep(node);
    tmp.properties.name = name;
    tmp.properties.args.inputData = inputData;
    if (selectors) {
      delete tmp.properties.args.condition;
      tmp.properties.args.conditions = {
        [`$${logic}`]: selectors.map(o => ({
          [`$${o.operator}`]: conditionVariables(o)
        }))
      };
    }
    nodeChange(tmp);
  };
  return (
    <>
      <NodeNameValidation
        label={t("modalPropiedadesLabelNodoValidacionNombre")}
        feedback={t("modalPropiedadesFeedbackValidacionNombre")}
        nodesNames={dependencies.nodeNames}
        oldName={node.properties.name}
        onSubmit={onSubmit}
      />
      <ConditionSelector
        operators={["eq", ">=", "<=", ">", "<", "!=", "notExists", "exists"]}
        inputData={inputData}
        setInputData={setInputData}
        selectors={selectors}
        logic={logic}
        setLogic={setLogic}
        context={dependencies.context}
        fields={"context"}
        setSelectors={setSelectors}
      />
    </>
  );
}
